import React from "react";
import BillboardCard from "./billboardCard";
import CardWithModal from "./cardWithModal";
import AdPopup from "../advertisement/advertisementDetail";
export default function UserProposalPopup({
  name,
  description,
  total_price,
  approved,
  billboard,
  advertisement,
}) {
  return (
    <div class="flex items-center justify-center" style={{ width: "50rem" }}>
      {/* <div class="absolute inset-0 bg-gray-900 opacity-75"></div> */}
      <div class="bg-white rounded-lg shadow-lg p-8">
        <h2 class="text-2xl font-bold mb-4">Proposal Details</h2>
        <div class="flex justify-center items-center gap-4">
          <div class="w-1/2">
            <CardWithModal
              advertisement={advertisement}
              modalContent={
                <AdPopup
                  name={advertisement?.advertisement_name}
                  type={advertisement?.advertisement_type}
                  mediaUrl={advertisement?.advertisement_file}
                />
              }
            />
          </div>
          <div class="w-1/2">
            <BillboardCard billboard={billboard} />
          </div>
        </div>
        <div class="flex justify-center items-center">
          <div class="flex flex-col mb-4 w-1/2">
            <label class="text-gray-600 font-bold mb-2" for="proposal-name">
              Name:
            </label>
            <span id="proposal-name" class="text-gray-800">
              {name}
            </span>
          </div>
          <div class="flex flex-col mb-4 w-1/2">
            <label class="text-gray-600 font-bold mb-2" for="proposal-desc">
              Description:
            </label>
            <span id="proposal-desc" class="text-gray-800">
              {description}
            </span>
          </div>
        </div>
        <div class="flex justify-end gap-4">
          <div class="flex flex-col mb-4">
            <label class="text-gray-600 font-bold mb-2" for="proposal-price">
              Total Price:
            </label>
            <span id="proposal-price" class="text-gray-800">
              $ {total_price}
            </span>
          </div>
          <div class="flex flex-col mb-4">
            <label class="text-gray-600 font-bold mb-2" for="proposal-status">
              Status:
            </label>
            <span id="proposal-status" class="text-gray-800">
              {approved === 2 ? (
                <p className="inline-flex rounded-full bg-green-500 bg-opacity-10 py-1 px-3 text-sm font-medium text-green-500">
                  Approved
                </p>
              ) : approved === 1 ? (
                <p className="inline-flex rounded-full bg-yellow-500 bg-opacity-10 py-1 px-3 text-sm font-medium text-yellow-500">
                  Pending
                </p>
              ) : (
                <p className="inline-flex rounded-full bg-red-500 bg-opacity-10 py-1 px-3 text-sm font-medium text-red-500">
                  Rejected
                </p>
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
